import { userConstants } from "../_constants";

export function updateOrderFrontStatus(state = {}, action) {
  switch (action.type) {
    case userConstants.UPDATE_ORDER_FRONT_STATUS_REQUEST:
      return {
        loading: true,
      };
    case userConstants.UPDATE_ORDER_FRONT_STATUS_SUCCESS:
      return {
        data: action.data.data,
      };
    case userConstants.UPDATE_ORDER_FRONT_STATUS_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}